export enum FilterOperator {
    EQUALS = 'eq',
    /** Used for matching all provided values in an array, i.e. multiple tags */
    EQUALS_ALL = 'eqAll',
    GREATER_THAN_OR_EQUAL = 'gteq',
    LESSER_THAN_OR_EQUAL = 'lteq',
    CONTAINS = 'contains',
}

export type FilterId = string
export type FilterValue = string | number | Date | undefined | null

export type Filter = {
    id?: FilterId
    key: string
    operator: FilterOperator
    value: FilterValue
    nonClearable?: boolean
}

export type FilterForPOST = {
    name: string
    operator: FilterOperator
    value: FilterValue
}
